<template>
  <div
    class="p-4 rounded-md whitespace-normal min-w-0 overflow-hidden hover:bg-muted"
  >
    <div class="flex items-center justify-between mb-3 gap-1.5">
      <span class="text-xs font-medium text-foreground">{{ $t("ЭЦП") }}</span>
      <div class="flex flex-col items-end">
        <div class="text-xs font-medium text-foreground">
          <span class="text-sm font-medium text-muted-foreground">{{
            $t("До")
          }}</span>
          {{ formattedDateAfter }}
        </div>
        <div
          v-if="remainingDays !== null && remainingDays < 60"
          class="text-[10px] leading-3 font-medium text-destructive"
        >
          {{ $t("Осталось") }} {{ remainingDays }} {{ $t("дней") }}
        </div>
      </div>
    </div>
    <Progress :model-value="displayPercentage" class="h-1" />
  </div>
</template>

<script>
import dateFormat from "@/shared/lib/date-format";
import { Progress } from "@/shared/ui/progress";

export default {
  name: "ProgressBar",
  components: { Progress },
  data() {
    return {
      dateBefore: null,
      dateAfter: null,
    };
  },
  mounted() {
    this.dateBefore = localStorage.getItem("cert_date_before");
    this.dateAfter = localStorage.getItem("cert_date_after");
  },
  computed: {
    remainingDays() {
      if (!this.dateAfter) return null;
      const end = new Date(this.dateAfter).getTime();
      const now = Date.now();
      const diff = end - now;
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      return days >= 0 ? days : 0;
    },
    formattedDateAfter() {
      return dateFormat.datetimeDisplay(this.dateAfter, "DD.MM.YYYY");
    },
    displayPercentage() {
      if (!this.dateBefore || !this.dateAfter) return 75;

      const start = new Date(this.dateBefore).getTime();
      const end = new Date(this.dateAfter).getTime();
      const now = Date.now();

      if (end <= start) return 100;

      const total = end - start;
      const elapsed = now - start;

      let percent = (elapsed / total) * 100;
      return Math.min(Math.max(percent, 0), 100);
    },
  },
};
</script>
